//librerías
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useNavigate } from "react-router-dom";

//componentes
import { Button, Container, Spinner } from "react-bootstrap";
import {
  faPen,
  faSquarePlus,
  faToggleOff,
  faToggleOn,
} from "@fortawesome/free-solid-svg-icons";

//context
import { AuthContext } from "../../../../context/AuthContext";

//interfaces
import { MarcaUnidadInterface } from "../../../../interfaces/MarcaUnidadInterface";

//hooks
import useFetch from "../../../../hooks/useFetch";
import { ColumnDef } from "@tanstack/react-table";
import CustomTable from "../../../Formularios/CustomTable/CustomTable";
import ForbiddenMessage from "../../../Mensajes/ForbiddenMessage";
import { toast } from "react-toastify";

//estilos
const classes = require("./MarcaUnidadTable.module.css").default;

const MarcaUnidadTable = () => {
  const authContext = useContext(AuthContext);
  //variables de estado
  const [marcaUnidad, setMarcaUnidad] = useState<MarcaUnidadInterface[]>();
  const { sendRequest, error, setError } = useFetch();
  const navigate = useNavigate();

  //Función que trata los marcaUnidad traídos de la BD.
  const transformData = useCallback((variable: any) => {
    setMarcaUnidad(variable.data);
  }, []);

  //Función que llama todos los marcaUnidad paginados
  useEffect(() => {
    sendRequest(
      {
        url: "/marca_unidad",
      },
      transformData
    );
  }, [sendRequest, transformData]);

  //Función que desactiva a un marcaUnidad.
  const changeMarcaUnidadStatus = useCallback(
    (idMarcaUnidad: number) => {
      if (window.confirm("¿Seguro que desea cambiar el estatus de la marca?")) {
        sendRequest(
          {
            url: `/marca_unidad/${idMarcaUnidad}`,
            method: "DELETE",
          },
          (variable: any) => {
            setMarcaUnidad([]);
            toast.success("La marca ha cambiado de estatus.", {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            sendRequest(
              {
                url: "/tipo_servicio",
              },
              transformData
            );
          }
        );
      }
    },
    [sendRequest, transformData]
  );

  const columns = useMemo<ColumnDef<MarcaUnidadInterface>[]>(
    () => [
      {
        header: "#",
        accessorKey: "id",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
      },
      {
        header: "Nombre",
        accessorFn: (row) => row.nombre,
        id: "nombre",
        cell: (info) => info.getValue(),
        footer: (props) => props.column.id,
      },
      {
        header: "Estatus",
        cell: (info) => info.getValue(),
        accessorFn: (row) => (row.estatus ? "Activo" : "Inactivo"),
      },
      {
        header: "Acciones",
        cell: (info) => (
          <div className="btn-group" role="group" aria-label="Basic example">
            <Button
              title="Editar marca"
              style={{ backgroundColor: "#2874A6", borderColor: "white" }}
              onClick={() =>
                navigate(
                  `/main/catalogos/marcaUnidad/edit/${info.row.original.id}`
                )
              }
              disabled={!authContext.tokenCan("MarcaUnidad:update")}
            >
              <FontAwesomeIcon icon={faPen as IconProp} />
            </Button>
            {/** Botón para ver eliminar*/}
            <Button
              title={
                info.row.original.estatus
                  ? "Deshabilitar marca"
                  : "Habilitar marca"
              }
              style={{ backgroundColor: "#0d5475", borderColor: "white" }}
              disabled={!authContext.tokenCan("MarcaUnidad:delete")}
              onClick={() => changeMarcaUnidadStatus(info.row.original.id)}
            >
              <FontAwesomeIcon
                icon={(info.row.original.estatus ? faToggleOn : faToggleOff) as IconProp}
              />
            </Button>
          </div>
        ),
        footer: (props) => props.column.id,
      },
    ],
    [changeMarcaUnidadStatus, navigate, authContext]
  );

  //Mientras se carga el contenido se muestra un spinner
  if (!marcaUnidad) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner animation="grow" variant="info" />
      </div>
    );
  }

  return (
    <Container>
      <h2>Lista de marcas de unidad</h2>
      {/** Botón para agregar marca */}
      {authContext.tokenCan("MarcaUnidad:store") && (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            title="Agregar una nueva marca de unidad"
            style={{
              backgroundColor: "#21618C",
              borderColor: "white",
              marginBottom: "10px",
            }}
            onClick={() => navigate(`/main/catalogos/marcaUnidad/crear`)}
          >
            <FontAwesomeIcon icon={faSquarePlus as IconProp} /> Nueva marca
          </Button>
        </div>
      )}

      {/** Alerta de permisos */}
      {error === 403 && (
        <ForbiddenMessage onCloseHandler={() => setError(null)} />
      )}
      <CustomTable
        {...{
          data: marcaUnidad,
          columns,
        }}
      />
    </Container>
  );
};

export default MarcaUnidadTable;
